/*
 * phobos-widerruf.js — Eingangsbeleg nach § 356a BGB.
 *
 * Ablauf: Formular abfangen -> Supabase-RPC `phobos_withdrawal_submit`
 * erzeugt einen dauerhaften Datensatz mit AUTORITATIVEM Server-Zeitstempel
 * und Belegnummer -> Beleg wird angezeigt und ist herunterladbar/druckbar.
 * Danach wird die Meldung zusätzlich an das Shopify-Kontaktformular geschickt,
 * damit der Händler seine gewohnte Benachrichtigung erhält.
 *
 * Ohne JavaScript oder bei Fehlern: das native Shopify-Formular wird normal
 * abgeschickt (Händler wird informiert) — es geht nichts verloren.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-widerruf]');
  if (!root) return;
  var form = root.querySelector('form');
  var panel = root.querySelector('[data-widerruf-receipt]');
  if (!form || !panel) return;

  var url = root.getAttribute('data-supabase-url');
  var key = root.getAttribute('data-supabase-key');
  if (!url || !key) return; // ohne Backend: natives Formular unverändert lassen

  function val(n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; }

  function fmt(iso) {
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
             ' um ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) + ' Uhr';
    } catch (e) { return iso; }
  }

  function receiptText(d) {
    return [
      'WIDERRUFSBESTÄTIGUNG (Eingangsbeleg nach § 356a BGB)',
      '',
      'Belegnummer:   ' + d.receipt_no,
      'Eingegangen:   ' + fmt(d.received_at),
      '',
      'Name:          ' + d.name,
      'E-Mail:        ' + d.email,
      'Bestellnummer: ' + d.order_ref,
      d.order_date ? 'Bestelldatum:  ' + d.order_date : '',
      d.note ? 'Anmerkung:     ' + d.note : '',
      '',
      'Hiermit wird der Eingang der Widerrufserklärung zum oben genannten',
      'Zeitpunkt bestätigt. Bitte diesen Beleg aufbewahren.',
      '',
      document.title
    ].filter(Boolean).join('\n');
  }

  function showReceipt(d) {
    panel.innerHTML =
      '<h2 class="h3">Widerruf eingegangen ✓</h2>' +
      '<p class="wform__receipt-lead">Wir haben deinen Widerruf verbindlich erfasst. Bitte bewahre diesen Beleg auf.</p>' +
      '<dl class="wform__receipt">' +
        '<dt>Belegnummer</dt><dd class="mono">' + d.receipt_no + '</dd>' +
        '<dt>Eingegangen am</dt><dd class="mono">' + fmt(d.received_at) + '</dd>' +
        '<dt>Bestellnummer</dt><dd class="mono">' + d.order_ref.replace(/[<>&]/g, '') + '</dd>' +
      '</dl>' +
      '<div class="wform__receipt-acts">' +
        '<button type="button" class="btn btn--signal btn--sm" data-dl>Beleg speichern</button>' +
        '<button type="button" class="btn btn--ghost btn--sm" data-print>Drucken</button>' +
      '</div>';
    form.hidden = true;
    panel.hidden = false;
    panel.setAttribute('tabindex', '-1');
    panel.focus();

    panel.querySelector('[data-dl]').addEventListener('click', function () {
      var blob = new Blob([receiptText(d)], { type: 'text/plain;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'Widerruf-' + d.receipt_no + '.txt';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
    });
    panel.querySelector('[data-print]').addEventListener('click', function () { window.print(); });
  }

  /* Händler zusätzlich per Shopify-Kontaktformular benachrichtigen (ohne Navigation) */
  function notifyMerchant() {
    try {
      var fd = new FormData(form);
      fd.set('form_type', 'contact');
      fd.set('utf8', '✓');
      fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    } catch (e) { /* unkritisch: Beleg ist bereits dauerhaft gespeichert */ }
  }

  function onSubmit(ev) {
    if (!form.reportValidity || !form.reportValidity()) return;
    ev.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Wird übermittelt …'; }

    var body = {
      name: val('contact[name]'),
      email: val('contact[email]'),
      order_ref: val('contact[Bestellnummer]'),
      order_date: val('contact[Bestelldatum]'),
      note: val('contact[body]')
    };

    fetch(url.replace(/\/$/, '') + '/rest/v1/rpc/phobos_withdrawal_submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: key, Authorization: 'Bearer ' + key },
      body: JSON.stringify({ payload: body }),
      /* Ohne Frist blieb der Knopf bei haengender Verbindung fuer immer auf
         „Wird übermittelt …". Nach 15 Sekunden greift der Ausweg unten und
         schickt das Formular klassisch ab. */
      signal: typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? AbortSignal.timeout(15000) : undefined
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http ' + r.status)); })
      .then(function (res) {
        if (!res || res.ok !== true) throw new Error((res && res.error) || 'unbekannt');
        notifyMerchant();
        showReceipt(Object.assign({}, body, res));
      })
      .catch(function () {
        /* Fallback: natives Formular abschicken, damit die Meldung sicher ankommt */
        if (btn) { btn.disabled = false; if (btn.dataset.label) btn.textContent = btn.dataset.label; }
        form.removeEventListener('submit', onSubmit);
        HTMLFormElement.prototype.submit.call(form);
      });
  }
  form.addEventListener('submit', onSubmit);
})();
